import '../MainFrame.css';
import "./ayuda.css"
import { useState } from 'react';


const Historial = (props) => {

    const [ListadoCons, SetListadoCons] = useState([])

  return (
    <div className='frame'>
        <div className='ayuda-title2'>
        <h2>Historial de Consultas</h2>
      </div>
      <div className='consultas-container'>
        <div className='consultas-list'>
            {(ListadoCons.length===0 ? <h3>No se registran consultas previas</h3> : <>Hay Consultas</>)}
        </div>
      </div>
    </div>
  )
}

export default Historial